/**
 * Format a message timestamp as locale time only (e.g. "3:42 PM").
 * @param {string | null | undefined} createdAt
 * @returns {string}
 */
export function formatMessageTime(createdAt) {
    if (!createdAt) return '';
    return new Date(createdAt).toLocaleTimeString(undefined, {
        hour: 'numeric',
        minute: '2-digit',
    });
}

/**
 * Format a date for thread dividers (e.g. "Jun 17, 2026").
 * @param {string | null | undefined} createdAt
 * @returns {string}
 */
export function formatDateDivider(createdAt) {
    if (!createdAt) return '';
    return new Date(createdAt).toLocaleDateString(undefined, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
}

/**
 * @param {string | null | undefined} createdAt
 * @returns {string}
 */
function getDayKey(createdAt) {
    if (!createdAt) return '';
    const d = new Date(createdAt);
    return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}

/**
 * Interleave date dividers between messages on different calendar days.
 * @param {{ id: string, createdAt: string }[]} messages
 * @returns {Array<{ type: 'divider', id: string, date: string } | { type: 'message', id: string, message: object }>}
 */
export function groupMessagesWithDividers(messages) {
    if (!messages?.length) return [];

    const items = [];
    let lastDayKey = null;

    messages.forEach((message, index) => {
        const dayKey = getDayKey(message.createdAt);
        if (dayKey !== lastDayKey) {
            items.push({
                type: 'divider',
                id: `divider-${dayKey}-${index}`,
                date: message.createdAt,
            });
            lastDayKey = dayKey;
        }
        items.push({ type: 'message', id: message.id, message });
    });

    return items;
}
